
const initialStore = {
  lead: {
    calculator: {}
  }
};

export default initialStore;


// WEBPACK FOOTER //
// ./src/store/initialStore.js